export default __webpack_public_path__ + "static/media/bulletVideo.5facc61b.svg";